import { FORTY_PERCENT_OFF_COUPON } from '@/components/app/layout/DiscountModal';
import { FlowConfig } from '@/components/SimplifiedSignup/Context/types';

import BlogDiscountScreensConfig from './Screens';

const BlogDiscountOfferFlow: FlowConfig = {
	activeScreenKey: 'account',
	activeScreenConfig: BlogDiscountScreensConfig.account,
	name: 'BlogDiscountOffer',
	pageName: 'blog-discount-offer',
	screens: {
		account: BlogDiscountScreensConfig.account,
		payment: BlogDiscountScreensConfig.payment,
		handoff: BlogDiscountScreensConfig.handoff,
	},
	plan: 'yearly',
	coupon: FORTY_PERCENT_OFF_COUPON,
	allowChurned: true,
	hasFreeTrial: false,
	offerCountries: null,
	offerCurrencies: null,
	fauxAuth: true,
};

export default BlogDiscountOfferFlow;
